import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'notApplicable' })
export class NotApplicablePipe implements PipeTransform {

  transform(data: string): string {
    return data || 'N/A';
  }
}
